import { getIconProps, type IconProps } from '#types'

/**
 * Rotate / refresh icon — circular arrow with arrowhead, indicating refresh
 * or reset actions.
 *
 * @example
 * ```tsx
 * <button aria-label="Refresh devices">
 *   <RotateIcon className="h-4 w-4" />
 * </button>
 * ```
 */
export function RotateIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.3051 3 16.4077 3.86656 18 5.29168M19 3V6C19 6.55228 18.5523 7 18 7H15"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
